<template>
<div class="part-list-container">
    <div class="hnw-area-center" id="talk-content">
        <!-- 商品详情组件 -->
       
        
        <!-- 商品列表部分 -->
        <div v-if="showPartsList" class="parts-list-section">
            
            <!-- 描述和详情图 -->
            <div class="parts-images" >
                <!-- <img :src="partsData.parts_desc" alt="描述图" class="parts-image"> -->
                <img :src="partsData.parts_image||brandInfo.url" alt="详情图" class="parts-image">
            </div>
            
            <!-- 商品列表 -->
            <GoodsList 
                :goods-list="paginatedPartsList"
                :total="partsList.length"
                :current-page="currentPage"
                :page-size="pageSize"
                :ac-sort="acSort"
                @sort="sortChange"
                @page-change="handleCurrentChange"
                @handleSizeChange="handleSizeChange"
                
            />
        </div>
        
        <!-- 原始页面内容 -->
        <div v-else>
            <div class="nav-list" :class="{'sticky': isNavSticky}" ref="navList">
                <div v-for="(brand,index) in brandList" :brand="brand.name" :key="index"  @click="getClassGoodsList(brand)" class="nav-item" :class="{'active':brandInfo.id==brand.id}"> 
                    <img :src="brand.icon" alt="" srcset="">
                </div> 
                
                <div class="btn cre" @click="exportToPNG">
                    生成海报
                </div>
                                                   
            </div>
            <div id="save-PNG-body">
                <div class="banner" @dblclick="exportToPNG">
                    <img :src="brandInfo.url" alt="" srcset="">
                </div>
                
                <!-- 原始商品列表 -->
                <div class="class-goods-list">
                    <div class="brand-modu" v-for="clasItem in classList" :key="clasItem.id">
                        <div class="brand-title">
                            <img :src="clasItem.url" alt="" srcset="">
                        </div>
                        <!-- 修改商品列表显示 -->
                        <div class="goods-list">
                            <el-row :gutter="20">
                                <el-col :span="3" v-for="goods in getDisplayGoods(clasItem.goodsList)" :key="goods.id" @click.native="toInfo(goods)">
                                    <div class="goods-item" :id="goods.name">
                                        <img :src="goods.url" alt="" srcset="">
                                        <div class="goods-text">
                                            {{ goods.name }}
                                        </div>
                                    </div>
                                </el-col>
                            </el-row>
                            <!-- 展开/收起按钮 -->
                            <div class="toggle-button" v-if="clasItem.goodsList && clasItem.goodsList.length > 8" @click="toggleGoodsList(clasItem)">
                                <i :class="clasItem.showAll ? 'el-icon-d-arrow-right' : 'el-icon-d-arrow-left'"></i>
                                <div class="toggle-text">{{ clasItem.showAll ? '收起' : '展开' }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     
    </div>
</div>
</template>

<script>
import GoodsList from '../../components/GoodsList.vue'
import GoodsInfo from '../../components/GoodsInfo.vue'
 import html2canvas from 'html2canvas';
 console.log(window.location);

 let replaStrat = window.location.hostname.startsWith('www.')?'https://www.':"https://";
 let imageUrl = replaStrat+ window.location.hostname +`/agent-image`;
//  const imageUrl = replaStrat+  +`/agent-image`;
export default {
    components: {
        GoodsList,
        GoodsInfo
    },
    data(){
        return{
            brandList:[],
            brandInfo:{},
            // 分类列表
            classList:[],
            // 控制是否显示商品列表
            showPartsList: false,
            // 商品列表数据
            partsList: [],
            // 分页相关数据
            currentPage: 1,
            pageSize: 10,
            // 排序相关
            acSort: '',
            // 配件数据
            partsData: null,
            // 导航栏吸附相关
            isNavSticky: false,
            navOffsetTop: 0,
            // 记录点击的商品名称
            clickedGoodsName: '',
            // 控制是否显示商品详情
            showGoodsDetail: false,
            selectedGoods: null,
            // 历史购买记录相关
            gooodsHisList: [],
            hisVis: false
        }
        
    },
    computed: {
        // 计算分页后的商品列表
        paginatedPartsList() {
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            return this.partsList.slice(start, end);
        },
        // 计算总数量
        total() {
            return this.partsList.length;
        }
    },
    watch: {
        showPartsList(newVal) {
            // 当showPartsList变化时，通知父组件
            this.$emit('update:showPartsList', newVal);
        }
    },
    methods:{
        async getBrand(){
            let res = await this.$api.getBrandTalk()
            
            // 获取过滤品牌列表
            const exBrands = this.$store.state.exBrands ? this.$store.state.exBrands.split(',') : [];
            
            // 如果有过滤品牌，则过滤品牌列表
            if (exBrands.length > 0) {
                res.db = res.db.filter(brand => {
                    // 特别处理"卢卡斯"品牌，需要同时检查"卢卡斯"和"Lucas"
                    if (brand.name === '卢卡斯' || brand.name === 'Lucas') {
                        return !exBrands.includes('卢卡斯') && !exBrands.includes('Lucas');
                    }
                    // 其他品牌直接检查是否在过滤列表中
                    return !exBrands.includes(brand.name);
                });
            }
            
            this.brandList = res.db
        },
        
        // 排序变化
        async sortChange(sortData) {
            const { field, order } = sortData;
            this.acSort = field + order;
            this.currentPage = 1;
            this.sortPartsList();
        },
        
        // 对商品列表进行排序
        sortPartsList() {
            if (!this.acSort) return;
            
            const sortField = this.acSort.replace(/[12]$/, '');
            const sortOrder = this.acSort.endsWith('1') ? 'asc' : 'desc';
            
            this.partsList.sort((a, b) => {
                let valueA = a[sortField];
                let valueB = b[sortField];
                
                // 处理数字类型
                if (sortField === 'goods_storage' || sortField === 'goods_price') {
                    valueA = parseFloat(valueA) || 0;
                    valueB = parseFloat(valueB) || 0;
                }
                
                if (sortOrder === 'asc') {
                    return valueA > valueB ? 1 : -1;
                } else {
                    return valueA < valueB ? 1 : -1;
                }
            });
        },
        
        async getClassGoodsList(brand){
            if(window.location.hostname=="localhost"){
                imageUrl = ""
            }
            if(brand&&brand.id){
                if(imageUrl){
                    brand.url = brand.url.replace('https://image.oos.huanuowei.cn', imageUrl)
                }
                
                this.brandInfo = brand
                let res = await this.$api.getBrandTalk(brand.id)
                res.db.forEach(async clasItem => {
                    if(imageUrl){
                        clasItem.url = clasItem.url.replace('https://image.oos.huanuowei.cn', imageUrl)
                    }
                    let claRes = await this.$api.getBrandTalk(clasItem.id)
                    // . = 
                    claRes.db.forEach(item => {
                        if(imageUrl){
                            item.url = item.url.replace('https://image.oos.huanuowei.cn', imageUrl)
                        }
                    })
                    claRes.db.sort((a, b) => {
                        const sortA = Number(a.sort) || 0;
                        const sortB = Number(b.sort) || 0;

                        return sortB - sortA;
                    });
                    this.$set(clasItem,"goodsList",claRes.db)
                    // 添加显示状态控制字段
                    this.$set(clasItem, "showAll", true)
                })
                this.classList = res.db
                
                
                // 回到页面顶部
                window.scrollTo(0, 0);
            }
        },

        async toInfo(goods){
           
            // 记录点击的商品名称
            this.clickedGoodsName = goods.name;
           
            // if(goods.data){
            //     this.$store.commit('UpDateState',{
            //         searchText:goods.data
            //     })
            //     this.$router.push("/find/index")
            // }
            
            
            if(goods.extend){
                
                let res = await this.$api.getBrandTalkParts(goods.extend)
                console.log("res",res);
                // 显示商品列表，隐藏原始列表
                this.showPartsList = true;
                // 保存配件数据
                this.partsData = {
                    parts_desc: goods.parts_desc,
                    parts_image: goods.parts_image
                };
                // 保存商品列表数据
                res.forEach(item => {
                    // 初始化商品数量
                    this.$set(item, "goods_num", 1);
                    // 初始化购物车数量
                    this.$set(item, "cartNum", 0);
                    item.goods_price = this.$handlePrice(item);
                    // 初始化互换件弹窗状态
                    this.$set(item, "replacePopVis", false);
                });
                
                // 添加品牌过滤逻辑
                const exBrands = this.$store.state.exBrands ? this.$store.state.exBrands.split(',') : [];
                if (exBrands.length > 0) {
                    res = res.filter(item => {
                        // 特别处理"卢卡斯"品牌，需要同时检查"卢卡斯"和"Lucas"
                        if (item.oenaturebrand === '卢卡斯' || item.oenaturebrand === 'Lucas') {
                            return !exBrands.includes('卢卡斯') && !exBrands.includes('Lucas');
                        }
                        // 其他品牌直接检查是否在过滤列表中
                        return !exBrands.includes(item.oenaturebrand);
                    });
                }
                
                // 按生产码(sccode)进行a-z 0-9排序
                res.sort((a, b) => {
                    const aCode = a.sccode || '';
                    const bCode = b.sccode || '';
                    return aCode.localeCompare(bCode, undefined, { numeric: true, sensitivity: 'base' });
                });

                this.partsList = res;
                // goods.parts_desc
                // goods.parts_image
                document.getElementById("hnw-header").scrollIntoView();
            }else if(goods.data){
                 // 显示商品列表，隐藏原始列表
                this.showPartsList = true;
                let searParams = {
                    store_curpage: 1,
                    store_page: 999,
                    search:goods.data, 
                };
                try {
                    // 显示商品列表，隐藏原始列表
                    this.showPartsList = true;
                    this.partsData = {
                        parts_desc: goods.parts_desc,
                        parts_image: goods.parts_image
                    };
                    let wmRes = await this.$api.getFindList(searParams);
                    console.log("wmRes",wmRes);
                    wmRes = wmRes.data[0]
                    
                    if(wmRes.goods_list&&wmRes.goods_list.length>0){
                        // 保存商品列表数据
                        wmRes.goods_list.forEach(item => {
                            // 初始化商品数量
                            this.$set(item, "goods_num", 1);
                            // 初始化购物车数量
                            this.$set(item, "cartNum", 0);
                            item.goods_price = this.$handlePrice(item);
                            // 初始化互换件弹窗状态
                            this.$set(item, "replacePopVis", false);
                        });
                        this.partsList = wmRes.goods_list;

                    }else{
                        this.partsList = [];
                        return console.log("列表为空");
                    }
                } catch (error) {
                    this.partsList = [];
                    return console.log("列表为空");
                    
                }
                document.getElementById("hnw-header").scrollIntoView();
            }
        },
        handleScroll() {
            // 获取导航栏距离顶部的距离
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            // 当滚动距离大于等于导航栏初始位置时，启用吸附效果
            // 当滚动距离小于导航栏初始位置时，取消吸附效果
            this.isNavSticky = scrollTop >= this.navOffsetTop;
            this.isTableHeadSticky = scrollTop >= this.tableHeadOffsetTop;
        },
        handleResize() {
            // 重新计算导航栏位置
            this.$nextTick(() => {
                if (this.$refs.navList) {
                    // 重新获取元素在页面中的绝对位置
                    const rect = this.$refs.navList.getBoundingClientRect();
                    this.navOffsetTop = rect.top + window.pageYOffset;
                }
                if (this.$refs.tableHead) {
                    // 重新获取元素在页面中的绝对位置
                    const rect = this.$refs.tableHead.getBoundingClientRect();
                    this.tableHeadOffsetTop = rect.top + window.pageYOffset;
                }
            });
        },
        // 获取要显示的商品列表
        getDisplayGoods(goodsList) {
            if (!goodsList) return [];
            // 查找当前分类项以获取showAll状态
            // 注意：这里使用find可能不是最佳方式，因为goodsList可能不是同一个引用
            // 但在当前场景下应该可以工作
            const clasItem = this.classList.find(item => item.goodsList === goodsList);
            if (clasItem && clasItem.showAll) {
                return goodsList;
            }
            return goodsList.slice(0, 8);
        },
        // 切换商品列表显示状态
        toggleGoodsList(clasItem) {
            clasItem.showAll = !clasItem.showAll;
            // 使用$set确保响应性
            this.$set(clasItem, "showAll", clasItem.showAll);
        },
        // 隐藏商品列表，显示原始列表
        hidePartsList() {
            this.showPartsList = false;
            this.$nextTick(() => {
                setTimeout(() => {
                    // 如果有记录的点击商品名称，则滚动到该商品
                    if (this.clickedGoodsName) {
                        const targetElement = document.getElementById(this.clickedGoodsName);
                        if (targetElement) {
                            // 使用更合适的滚动选项，确保元素可见
                            targetElement.scrollIntoView({ 
                                behavior: 'smooth', 
                                block: 'center', 
                                inline: 'nearest' 
                            });
                        }
                    } 

                }, 0);
            })
        },
        // 分享商品
        shareGoods(goods) {
            // 分享功能实现
            this.$message.info('分享商品')
        },
        
        showGoodsInfo(goods) {
            goods.preRou = "自主专区";
            this.selectedGoods = goods;
            localStorage.setItem("hnw-web-item-data", JSON.stringify(goods));
            // 通知父组件显示商品详情
            this.$emit('showGoodsDetail', goods);
        },
        
        // 隐藏商品详情
        hideGoodsDetail() {
            this.showGoodsDetail = false;
            this.selectedGoods = null;
        },
        
        handleCurrentChange(val) {
            this.currentPage = val;
            // 滚动到顶部
            this.$nextTick(() => {
                document.querySelector('.zone-parts-table-container').scrollIntoView({ behavior: 'smooth' });
            });
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.getClassGoodsList(this.brandList[0])
        },
        
        async exportToPNG() {
          console.log("save-PNG-body",11);
         
          const element = document.getElementById('save-PNG-body');
          // 使用 html2canvas 截图
          const canvas = await html2canvas(element, {
            backgroundColor: null, // 保留透明背景
            useCORS: true, // 如果有跨域图片资源，启用该选项
            scale: window.devicePixelRatio * 2, // 提高缩放比例，使用设备像素比的2倍
            dpi: 300, // 设置高DPI
            logging: false // 关闭日志
          });

          // 将 canvas 转换为 base64 图片
          const base64Image = canvas.toDataURL('image/png');
          
          const response = await fetch(base64Image);
          const blob = await response.blob();

          // 创建 ClipboardItem

          const clipboardItem = new ClipboardItem({ [blob.type]: blob });

          // 写入剪贴板
          await navigator.clipboard.write([clipboardItem]);

          this.$suMsg("已复制到剪切板")
          // 设置到页面上显示
          this.imageSrc = base64Image;
          // 可选：自动下载图片
          
          this.downloadImage(base64Image, this.brandInfo.name+'.png');
          // this.shareVis = false
        },
        downloadImage(dataUrl, filename) {
          const a = document.createElement('a');
          a.href = dataUrl;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        },
        async fdownloadImage(url, filename = 'test.jpg') {
          try {
            // 1. 获取图片数据
            const response = await fetch(url);
            if (!response.ok) throw new Error('图片获取失败');

            const blob = await response.blob();

            // 2. 创建临时下载链接
            const downloadUrl = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = downloadUrl;
            a.download = filename; // 指定下载的文件名

            // 3. 触发下载
            document.body.appendChild(a);
            a.click();

            // 4. 清理
            document.body.removeChild(a);
            URL.revokeObjectURL(downloadUrl);
          } catch (error) {
            console.error('下载失败:', error);
          }
        },
    },
    async created(){
        await this.getBrand()
        await this.getClassGoodsList(this.brandList[0])
    },
    mounted() {
        // 计算导航栏初始位置
        this.$nextTick(() => {
            if (this.$refs.navList) {
                // 获取元素在页面中的绝对位置
                const rect = this.$refs.navList.getBoundingClientRect();
                this.navOffsetTop = rect.top + window.pageYOffset;
            }
            if (this.$refs.tableHead) {
                // 获取元素在页面中的绝对位置
                const rect = this.$refs.tableHead.getBoundingClientRect();
                this.tableHeadOffsetTop = rect.top + window.pageYOffset;
            }
            
            // 如果有记录的点击商品名称，则滚动到该商品
            if (this.clickedGoodsName && !this.showPartsList) {
                setTimeout(() => {
                    const targetElement = document.getElementById(this.clickedGoodsName);
                    if (targetElement) {
                        targetElement.scrollIntoView({ 
                            behavior: 'smooth', 
                            block: 'center', 
                            inline: 'nearest' 
                        });
                    }
                }, 500);
            }
        });
        
        // 添加滚动和窗口大小调整事件监听器
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        // 移除事件监听器
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    },
    props:{
        
    }
}
</script>

<style lang="scss">
.part-list-container{
    
    padding-top: 10px;
    .pages{
        text-align: right;
        padding: 5px 0;
    }
    #talk-content{
        position: relative;
        
        .nav-list{
            width: 100%;
            display: flex;
            justify-content: space-between;
            // overflow-x: auto;
            padding: 5px 0;
            background: #fff;
            margin-bottom: 10px;
            z-index: 100;
            position: relative;
            // 吸附样式
            &.sticky {
                position: fixed;
                top: 0;
                left: 50%;
                transform: translateX(-50%);
                width: calc(100% - 40px); // 考虑左右padding
                max-width: 1200px; // 限制最大宽度
                box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                margin-bottom: 0;
                padding: 10px 0;
            }
            
            .nav-item{
                flex-shrink: 0;
                background-color: #fff;
                padding: 3px 8px;
                text-align: center;
                cursor: pointer;
                display: flex;
                align-items: center;
                flex-direction: column;
                justify-content: center;
                margin: 0 3px;
                border-radius: 4px;
                
                img{
                    width: 260px;
                    // height: 80px;
                    // f1
                }
                
            }
            .active{
                // border: 3px solid #063376;
                background: #063376;
                color: #fff;
            }
            .btn{
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 10px 16px;
                font-size: 12px;
                border-radius: 32px;
                position: absolute;
                right: 0;
                bottom: -44px;
                z-index: 1;
                background: #063376;
                color: #fff;
            }
        }
        .banner{
            img{
                width: 100%;
            }
        }
        
        // 配件图片样式
        .parts-images {
            // display: flex;
            // justify-content: space-between;
            margin-bottom: 10px;
            
            .parts-image {
                width: 100%;
                height: auto;
            }
        }
        
        .class-goods-list{
            .brand-modu{
                margin-top: 10px;
                background: #fff;
            }
            .brand-title{
                display: flex;
                justify-content: center;
                padding: 10px 0;
                img{
                    height: 34px;
                }
            }
            
            .goods-list{
                padding: 0 10px;
                // padding-bottom: 10px;
                // 使用Element UI的栅格系统，移除原来的flex布局
                .goods-item{
                    // margin-bottom: 10px;
                    cursor: pointer;
                    text-align: center;
                    margin-bottom: 8px;
                    img{
                        width: 100%;
                        // height: 80px;
                        object-fit: cover;
                    }
                    &:hover{
                        transform: scale(1.1);
                    }
                    .goods-text{
                        padding: 5px 0;
                        font-size: 12px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
                .toggle-button {
                    text-align: center;
                    padding-bottom: 5px;
                    cursor: pointer;
                    color: #666;
                    font-size: 16px;
                    // display: flex;
                    // align-items: center;
                    // justify-content: center;
                    i{
                        transform: rotate(-90deg);
                    }
                    .toggle-text {
                        // margin-left: 5px;
                    }
                }
            }
        }
        
        // 商品列表样式（使用旧配件列表样式）
        .zone-parts-table-container {
            background-color: #fff;
            border-radius: 4px;
            padding: 5px;
            
            // 表头样式
            .product {
                height: 40px;
                background: #c4c9cc;
                .teble-head {
                    display: flex;
                    li {
                        display: flex;
                        height: 40px;
                        justify-content: center;
                        align-items: center;
                        position: relative;
                        color: #666;
                        &.oecode {
                            min-width: 250px;
                            max-width: 250px;
                        }
                        &.goods_name {
                            min-width: 180px;
                            max-width: 180px;
                        }
                        &.sccode {
                            min-width: 120px;
                            max-width: 120px;
                        }
                        &.oenaturebrand {
                            min-width: 120px;
                            max-width: 120px;
                        }
                        &.goods_storage {
                            width: 150px;
                        }
                        &.goods_price {
                            width: 82px;
                            position: relative;
                        }
                        .ico {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            margin-left: 5px;
                            > i {
                                cursor: pointer;
                                font-size: 12px;
                            }
                            i:hover {
                                transform: scale(1.5);
                                color: #3E84D6;
                            }
                            .el-icon-caret-top {
                                position: relative;
                                top: 3px;
                            }
                            .el-icon-caret-bottom {
                                position: relative;
                                top: -3px;
                            }
                            .active {
                                color: #3E84D6;
                            }
                        }
                        &.specification {
                            width: 90px;
                        }
                        &.numAd {
                            width: 114px;
                        }
                        &.handle-box {
                            width: 86px;
                        }
                    }
                }
            }
            
            // 旧配件列表样式
            .cargo {
                display: flex;
                box-sizing: border-box;
                position: relative;
                box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.13);
                margin-bottom: 20px;
                > ul {
                    width: 100%;
                }
                .case-list {
                    &.isAll {
                        height: auto;
                    }
                }
                .case-list:nth-child(2n) {
                    background: #f7f7f7;
                }
                
                .details {
                    display: flex;
                    position: relative;
                    .watermark-text{
                        position: absolute;
                        left: 20%;
                        top: 20%;
                    }
                    .watermark-text2{
                        left: 68%;
                    }
                    >div{
                        box-sizing: border-box;
                    }
                    .isOe {
                        position: relative;
                        width: 250px;
                        border-right: 1px solid #e3e4ea;
                        display: flex;
                        justify-content: space-between;
                        
                        .isOe-left {
                            width: 98%;
                            .isOe-top {
                                display: flex;
                                margin-top: 14px;
                                margin-bottom: 10px;
                                margin-left: 10px;
                                position: relative;
                                .hnw-copy{
                                    position: absolute;
                                    right: 36px;
                                    top: -6px;
                                }
                                .name {
                                    width: 48px;
                                    height: 20px;
                                    background-color: #3E84D6;
                                    font-size: 12px;
                                    text-align: center;
                                    line-height: 20px;
                                    color: #fff;
                                }
                                .number {
                                    cursor: pointer;
                                    max-width: 100px;
                                    margin-left: 5px;
                                    margin-top: 2px;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                    padding-top: 0;
                                    color: #333;
                                }
                                .tag-icon {
                                    display: flex;
                                    align-items: center;
                                    transform: scale(0.7);
                                    justify-content: center;
                                    width: 20px;
                                    height: 20px;
                                    background: #3E84D6;
                                    color: #fff;
                                    border-radius: 50%;
                                    font-size: 12px;
                                    position: relative;
                                    top: -8px;
                                    left: 2px;
                                }
                            }
                            .vehicleModel {
                                margin: 0 0 0 10px;
                                max-width: 230px;
                                box-sizing: border-box;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                cursor: pointer;
                                font-size: 14px;
                                color: #999;
                            }
                        }
                    }

                    .productName {
                        width: 180px;
                        height: 69px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        border-right: 1px solid #e3e4ea;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        position: relative;
                        gap: 2px;
                        .product-top{
                            position: absolute;
                            right: 0px;
                            top: 0px;
                            display: flex;
                            align-items: center;
                            padding-right: 5px;
                            >div{
                                cursor: pointer;
                            }
                            .dis-good-tips-small {
                                background: url(../../assets/newHome/折扣.png);
                                background-size: 40px 20px;
                                width: 40px;
                                height: 20px;
                                margin-left: 6px;
                                text-align: center;
                                line-height: 20px;
                                font-family: Source Han Sans CN;
                                font-weight: 500;
                                font-size: 12px;
                                color: #FFFFFF;
                                z-index: 99;
                            }
                            .cx-icon{
                                width: 22px;
                                margin-left: 8px;
                            }
                        }
                        .share-btn{
                            line-height: 1;
                            margin-left: 6px;
                            
                            img{
                                width: 20px;
                            }
                        }
                        .delivery-time{
                        }
                    }

                    .encoding {
                        overflow: hidden;
                        width: 120px;
                        height: 69px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        border-right: 1px solid #e3e4ea;
                        text-overflow: ellipsis;
                        position: relative;
                        .hnw-copy{
                            position: absolute;
                            right: 20px;
                            top: 8px;
                        }
                    }
                    
                    .brand {
                        overflow: hidden;
                        width: 120px;
                        height: 69px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        border-right: 1px solid #e3e4ea;
                        text-overflow: ellipsis;
                        position: relative;
                        .hnw-self-brand {
                            position: absolute;
                            bottom: -25px;
                            left: 50%;
                            transform: translateX(-50%);
                            color: #ff7519;
                        }
                    }
                    
                    // 自选品牌
                    .selfBrand {
                        background: #d9ecff;
                        border-bottom: 1px solid #ccc;
                    }
                    
                    .inventory {
                        width: 150px;
                        box-sizing: border-box;
                        border-right: 1px solid #e3e4ea;
                        text-align: center;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        padding: 5px 0;
                        .goods-location{
                            >div{
                                color: #2473FF;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                margin-right: 3px;
                            }
                        }
                        .loca-btn{
                            cursor: pointer;
                            padding: 1px;
                            color: #fff;
                            background: #FFAB00;
                            width: 66px;
                            text-align: center;
                            margin: 2px auto 0;
                        }
                        .goods-cangTip{
                            color: #F94F4C;
                            font-size: 12px;
                            // margin-left: 5px;
                            margin-top: 2px;
                            font-weight: bold;
                        }
                    }
                    
                    .TheOrderPrice {
                        position: relative;
                        width: 82px;
                        height: 69px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        border-right: 1px solid #e3e4ea;
                        text-overflow: ellipsis;
                        .watermark-text{
                            right: 0px !important;
                            top: -4px;
                        }
                        span {
                            position: relative;
                            top: 1px;
                        }
                    }

                    .specification {
                        overflow: hidden;
                        width: 90px;
                        height: 69px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        border-right: 1px solid #e3e4ea;
                        text-overflow: ellipsis;
                    }

                    .numAd {
                        width: 114px;
                        height: 69px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        border-right: 1px solid #e3e4ea;
                        position: relative;
                        .el-input-number {
                            // margin: 0 0px 0 10px;
                            width: 100px;
                        }
                        .goods-Fcl-tit {
                            position: absolute;
                            left: 50%;
                            transform: translateX(-50%);
                            bottom: 2px;
                            font-size: 12px;
                            line-height: 12px;
                            width: 120px;
                            text-align: center;
                            color: #999;
                        }
                        .red {
                            color: red;
                        }
                    }

                    .handle-box {
                        position: relative;
                        box-sizing: border-box;
                        padding: 5px 0;
                        width: 86px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        .addition {
                            font-size: 14px;
                            color: #999;
                        }
                        .replace-btn {
                            color: #3E84D6;
                            cursor: pointer;
                        }
                        .add-btn {
                            width: 80px;
                            height: 22px;
                            padding: 0;
                            color: #59a8f8;
                            font-size: 14px;
                            font-weight: 400;
                            line-height: 20px;
                            border-radius: 0px;
                            text-align: center;
                            cursor: pointer;
                        }
                        .add-btn:active{
                            transform: scale(1.1);
                        }
                        .ycg-btn {
                            background: #f5f5f5;
                            color: #999;
                            border: 1px solid #dcdfe6;
                        }
                    }
                }
                
                .goods-ex-msg {
                    display: flex;
                    border-top: 1px solid #e3e4ea;
                    justify-content: flex-end;
                    align-items: center;
                    line-height: 30px;
                    height: 30px;
                    .buyHis {
                        cursor: pointer;
                        text-align: right;
                        padding: 0 5px;
                        color: red;
                        font-size: 12px;
                        > span {
                            margin-right: 10px;
                            align-items: center;
                        }
                        .readMore {
                            cursor: pointer;
                        }
                    }
                }
            }
        }
        
        // 历史购买记录弹窗样式
        .el-dialog__body {
            padding: 0 !important;
            .his-list {
                .list-head {
                    display: flex;
                    height: 40px;
                    align-items: center;
                    background: #eeeeee;
                    margin: 10px 0;
                    padding: 0 8px;
                    > div {
                        flex: 1;
                        text-align: center;
                    }
                    .col-100 {
                        max-width: 100px;
                    }
                }
                .list-body {
                    .row {
                        display: flex;
                        padding: 0 8px;
                        > div {
                            flex: 1;
                            padding: 2px 0;
                            border-bottom: 1px solid #eee;
                            flex: 1;
                            text-align: center;
                            line-height: 28px;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                        .col-100 {
                            max-width: 100px;
                        }
                    }
                }
            }
        }
        
        .disabled-color{
            color: #999;
            font-weight: 400;
            font-size: 14px;
        }
    }

// 表头吸附样式
.product.sticky {
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: calc(100% - 40px); // 考虑左右padding
    max-width: 1200px; // 限制最大宽度
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    z-index: 99;
    background: #c4c9cc;
}

// 配件详情覆盖层样式
.goods-info-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
  
  .goods-info-container {
    background: #fff;
    width: 90%;
    max-width: 1200px;
    max-height: 90vh;
    overflow-y: auto;
    position: relative;
    border-radius: 4px;
    
    .close-button {
      position: absolute;
      top: 10px;
      right: 10px;
      cursor: pointer;
      z-index: 2001;
      background: #f00;
      color: #fff;
      padding: 5px 10px;
      border-radius: 4px;
      font-size: 14px;
    }
}
}
}

</style>
